import { combineReducers } from 'redux';

import twoFactor from './twoFactor/twoFactorReducer';

export default combineReducers({
	twoFactor,
});
